/* eslint-disable */
export default {
  en: {
    common: {
      constants:{
        durations: {
          none: 'incorrect duration',
          seconds: { multiple: 'seconds', single: 'second' },
          minutes: { multiple: 'minutes', single: 'minute' },
          hours: { multiple: 'hours', single: 'hour' },
          days: { multiple: 'days', single: 'day' },
          months: { multiple: 'months', single: 'month' },
          years: { multiple: 'years', single: 'year' }
        }
      },
      maintenance: {
        notify: {
          title: 'Starling is getting an upgrade!',
          message: 'In <strong>{countdown}</strong>, we’ll be unavailable for a short maintenance period of approximately <strong>{duration}</strong>.<br/> We apologize for the inconvenience and appreciate your patience as we work to make Starling the best it can be.'
        },
        in_progress: {
          title: 'Starling is getting an upgrade!',
          message: [
            'We\'re temporarily down for maintenance.',
            'We apologize for the inconvenience and appreciate your patience as we work to make Starling the best it can be.'
          ],
          estimation: 'Estimated time remaining : {remaining}',
          unknown_estimation: 'Please check again later!',
          over_estimated: 'Oops, we are running late ... again !'
        },
        done: {
          title: 'Starling has been upgraded!',
          message: ['We are back online!', 'Please click on the button below to go back to Starling.']
        },
        scheduled: {
          title: 'Starling is getting an upgrade!',
          message: ['We\'ll soon be unavailable for a short maintenance period.', ' We apologize for the inconvenience and appreciate your patience as we work to make Starling the best it can be.'],
          estimation: 'Maintenance will start in : {remainingBeforeMaintenance}'
        }
      },
      download: {
        prompt: {
          title: 'Add a password to protect this file',
          content: 'The file you are about to download contains sensitive member information. It is <strong>your responsibility</strong> to safeguard this data and ensure its confidentiality.<br/><br/> Password protection helps prevent any unauthorized access or disclosure.',
          placeholder:'Password',
          accept:'I understand',
          error:'The password must contain at least 5 characters.'
        }
      }
    },
    menu: {
      operational: 'Operational',
      dashboard: 'Dashboard',
      send_referral: 'Send Referral',
      view_leaderboard: 'View Leaderboard',
      view_referrals: 'View Referrals',
      view_members: 'View Members',
      member_reports: 'Member Reports',
      analysis: 'Reports'
    },
    profile: {
      header_title: 'My Profile',
      noChoice: 'None / Unknown',
      selectOption: 'Select an option',
      team: 'Team'
    },
    analysis: {
      header_title: 'Reports'
    },
    dashboard: {
      header_title: 'Dashboard',
      block: {
        referrals_stats: {
          title: 'Referral Stats',
          indicators: {
            this_month: 'My Referrals This Month',
            last_90_days: 'My Referrals in the Last 90 Days',
            not_yet_accepted_after_90_days: 'Referrals Not Yet Accepted After 90 Days',
            actives: 'Referrals Not Yet Accepted',
            unclaimed_over_7_days: 'Unregistered Referrals After 7+ Days Old',
            mean_org: 'Avg. referrals this month in my Org.',
            expired: 'Expired Referrals'
          }
        },
        unclaimed_referrals: {
          title: 'Referrals Not Yet Accepted',
          none: 'No data available',
          columns: {
            sent: 'Date Sent',
            since: 'Time Since Referral',
            name: 'Name',
            id: 'Disability ID',
            status: 'Status'
          },
          buttons: {
            view_less: 'View Less',
            view_more: 'View More',
            view_all: 'View All Referrals',
            resend: 'Resend',
            view: 'View',
            edit: 'Edit'
          },
          confirmations: {
            resend: {
              title: 'Resend Referral ?',
              text: 'Are you sure you want to re-send the notification to claimant {firstname} {lastname}?'
            }
          },
          notifications: {
            sent: {
              title: 'Notification sent',
              text: 'The claimant {firstname} {lastname} has been correctly notified.'
            },
            not_sent: {
              title: 'Notification not sent',
              text: 'An error occured. The claimant {firstname} {lastname} has not been notified.'
            }
          }
        },
        members: {
          title: 'Members (Accepted Referrals)',
          none: 'No data available',
          columns: {
            name: 'Name',
            id: 'Disability ID',
            program: 'Program',
            referral_date: 'Date Referred',
            checkup_date: 'Last Check-up',
            days_registration: 'Time Since Registration',
            days_referral_accepted: 'Time Since Referral Accepted',
            phq9_self_harm: 'PHQ9 Self Harm'
          },
          confirmations: {
            discharge: {
              title: 'Confirm Discharge',
              text: 'By discharging a referral, you will no longer be able to see them in HQ. Are you sure you want to proceed?'
            },
            notifications: {
              sent: {
                title: 'Dicharged',
                text: 'The referral has been successfully discharged.'
              },
              not_sent: {
                title: 'Discharge not successful',
                text: 'An error occured. The referral has not been discharged. Please try again'
              }
            }
          },
          buttons: {
            view_less: 'View Less',
            view_more: 'View More',
            view_all: 'View All Members',
            view: 'View',
            discharge: 'Discharge'
          },
          members_stats: {
            title: 'Member Stats',
            indicators: {
              members_without_login: 'Members without logins',
              members_logged_in_this_month: 'Members logged in this month',
              members_inactive_over_30_days: 'Members inactive over 30 days',
              my_total_members: 'My total Members'
            }
          }
        },
        leaderboard: {
          title: 'Leaderboard',
          none: 'No data available',
          selectOption: 'Select an option',
          team: 'Team',
          columns: {
            first_name: 'First Name',
            last_name: 'Last Name',
            total_referrals: 'Total Referrals',
            accepted_referrals: 'Accepted Referrals',
            acceptance_rate: 'Acceptance Rate',
            expired_referrals: 'Expired Referrals'
          },
          buttons: {
            view_less: 'View Less',
            view_more: 'View More',
            view_all: 'View All Leaders'
          },
        },
      },
      buttons: {
        send_referral: 'Send a Referral'
      }
    },
    send_referral: {
      header_title: 'Send a Referral for {name}',
      claimant: {
        title: 'Who do you want to refer to Starling?',
        fields: {
          firstname: 'First Name',
          lastname: 'Last Name',
          email: 'Email',
          businessUnit: 'Business Unit',
          language: 'Language',
          profession: 'Profession',
          noChoice: 'None / Unknown',
          selectOption: 'Select an option',
          team: 'Team'
        }
      },
      claim: {
        title: 'How do you identify them?',
        fields: {
          claimNumber: 'User ID',
          claimNumberHint: '(Ex: Claim Number or Identification Number)',
          policyNumber: 'Policy Number'
        }
      },
      action: {
        title: 'Please select a Program for them:',
        fields: {
          program: 'Program',
          lastDayAtWork: 'Last Day at Work'
        }
      },
      training_assignment: {
        title: '(Optional) Select content to assign:',
        fields: {
          training: {
            title: 'Training',
            placeholder: 'Choose a training module',
          },
        },
      },
      checkup: {
        title: '(Optional) Assign Check-Up Cadence:',
        fields: {
          checkup_frequency: 'Frequency',
          checkup_amount: 'Amount',
        },
        frequency_options: {
          member_discretion: 'Member\'s discretion',
          every_week: 'Every week',
          two_weeks: 'Every 2 weeks',
          three_weeks: 'Every 3 weeks',
          four_weeks: 'Every 4 weeks',
        },
        amount_options: {
          member_discretion: 'Member\'s discretion',
          qty_checkups: '{qty} Check-Ups',
        }
      },
      message: {
        title: 'Would you like to add a message to the referral email?'
      },
      buttons: {
        send: 'Send Referral',
        preview: 'Preview',
        cancel: 'Cancel'
      }
    },
    view_referrals: {
      header_title: 'Your Referrals',
      first_sent: 'First Sent',
      name: 'Name',
      program: 'Program',
      referral_status: 'Status',
      view_member: 'View Member',
      team: 'Team',
      buttons: {
        edit: 'Edit',
        resend: 'Resend',
        view: 'View',
        view_member: 'View Member',
        cancel: 'Cancel'
      },
    },
    view_referral: {
      header_title: 'Your Referrals',
      block: {
        timeline: {
          title: 'Timeline',
          types: {
            CREATED: 'Created',
            CREATED_FROM: 'Duplicated',
            NOTIFICATION_SENT: 'Notification Sent',
            BOUNCED: 'Notification Not Delivered',
            OPENED: 'Opened',
            LINK_CLICKED: 'Link Clicked',
            CANCELLED: 'Cancelled',
            ACCEPTED: 'Accepted',
            EXPIRED: 'Expired'
          }
        },
        information: {
          title: 'Information',
          claimant: {
            title: 'Who do you want to refer to Starling?',
            fields: {
              firstname: 'First Name',
              lastname: 'Last Name',
              email: 'Email',
              businessUnit: 'Business Unit',
              profession: 'Profession',
              language: 'Language'
            }
          },
          claim: {
            title: 'How do you identify them?',
            fields: {
              claimNumber: 'Disability ID',
              policyNumber: 'Policy Number'
            }
          },
          action: {
            title: 'Please select a Program for them:',
            fields: {
              program: 'Program',
              lastDayAtWork: 'Last Day at Work',
              team: 'Team'
            }
          },
          training_assignment: {
            title: '(Optional) Select content to assign:',
            fields: {
              training: {
                title: 'Training',
                placeholder: 'Choose a training module',
              },
            },
          },
          checkup: {
            title: '(Optional) Assign Check-Up Cadence:',
            fields: {
              checkup_frequency: 'Frequency',
              checkup_amount: 'Amount',
            },
            frequency_options: {
              member_discretion: 'Member\'s discretion',
              every_week: 'Every week',
              two_weeks: 'Every 2 weeks',
              three_weeks: 'Every 3 weeks',
              four_weeks: 'Every 4 weeks',
            },
            amount_options: {
              member_discretion: 'Member\'s discretion',
              qty_checkups: '{qty} Check-Ups',
            }
          },
          message: {
            title: 'Would you like to add a message to the referral email?'
          }
        }
      },
      buttons: {
        resend: 'Resend',
        delete: 'Delete',
        view_email: 'View Email',
        edit: 'Edit'
      }
    },
    edit_referral: {
      header_title: 'Edit Referral Details'
    },
    filters: {
      title: 'Filters',
      REFERRAL_DATES: {
        title: 'Dates',
        values: {
          NO_FILTER: 'No Filter',
          CURRENT_WEEK: 'Current Week',
          CURRENT_MONTH: 'Current Month',
          LAST_7_DAYS: 'Last 7 days',
          LAST_30_DAYS: 'Last 30 days'
        }
      },
      REFERRAL_STATUS: {
        title: 'Status',
        values: {
          SENT: 'Sent',
          RESEND: 'Resend',
          OPENED: 'Opened',
          LINK_CLICKED: 'Link Clicked',
          ACCEPTED: 'Accepted',
          CANCELLED: 'Cancelled',
          EXPIRED: 'Expired',
          ERRORED: 'Failed',
          DISCHARGED: 'Discharged',
        }
      },
      REFERRAL_PROGRAMS: {
        title: 'Programs',
        values: {
          none: 'None',
          MENTAL_FITNESS: 'Mental Fitness',
          RTH_MENTAL: 'Return to Health - Mental',
          RTH_PHYSICAL: 'Return to Health - Physical',
          RTH_VETERANS: 'Return to Health - Veterans'
        }
      },
      MEMBERS_PROGRAMS: {
        title: 'Programs',
        values: {
          MENTAL_FITNESS: 'Mental Fitness',
          RTH_MENTAL: 'Return to Health - Mental',
          RTH_PHYSICAL: 'Return to Health - Physical',
          RTH_VETERANS: 'Return to Health - Veterans'
        }
      },
      MEMBERS_DATES: {
        title: 'Member since',
        values: {
          NO_FILTER: 'No Filter',
          CURRENT_WEEK: 'Current Week',
          CURRENT_MONTH: 'Current Month',
          LAST_7_DAYS: 'Last 7 days',
          LAST_30_DAYS: 'Last 30 days'
        }
      },
      MEMBERS_REPORTS_DATES: {
        title: 'Member since',
        values: {
          NO_FILTER: 'No Filter',
          LAST_EXECUTION: 'Last Execution',
          PREVIOUS_EXECUTION: 'Previous Execution',
          CURRENT_WEEK: 'Current Week',
          CURRENT_MONTH: 'Current Month',
          LAST_7_DAYS: 'Last 7 days',
          LAST_30_DAYS: 'Last 30 days'
        }
      },
      DOWNLOADED_REPORTS: {
        title: 'Show Downloaded Reports'
      },
      MEMBERS_REPORTS_LIST: {
        title: 'Members'
      },
      REPORT_CREATED_DATES: {
        title: 'Report Date'
      },
      REPORT_ACCEPTED_DATES: {
        title: 'Accepted Date'
      },
      HQ_USERS_REPORTS_LIST: {
        title: 'HQ Users'
      },
      HQ_TEAMS: {
        title: 'Teams'
      },
      ACCESS_CODES: {
        title: 'Programs',
        values: {
          MENTAL_FITNESS: 'Mental Fitness',
          RTH_MENTAL: 'Return to Health - Mental',
          RTH_PHYSICAL: 'Return to Health - Physical',
          RTH_VETERANS: 'Return to Health - Veterans'
        }
      },
      ANALYSIS_DATES: {
        title: 'Date',
        values: {
          NO_FILTER: 'No Filter',
          CURRENT_WEEK: 'Current Week',
          CURRENT_MONTH: 'Current Month',
          LAST_7_DAYS: 'Last 7 days',
          LAST_30_DAYS: 'Last 30 days'
        }
      },
      ANALYSIS_PROGRAMS: {
        title: 'Programs',
        values: {
          MENTAL_FITNESS: 'Mental Fitness',
          RTH_MENTAL: 'Return to Health - Mental',
          RTH_PHYSICAL: 'Return to Health - Physical',
          RTH_VETERANS: 'Return to Health - Veterans'
        }
      },
      ANALYSIS_PROFESSIONS: {
        title: 'Professions'
      },
      ANALYSIS_BUSINESS_UNITS: {
        title: 'Business Units'
      },
      ANALYSIS_LOCALES: {
        title: 'Locales'
      },
      ANALYSIS_ACCESS_CODES: {
        title: 'Access Codes'
      }
    },
    view_members: {
      header_title: 'View Members',
      member_since: 'Member Since',
      name: 'Name',
      program: 'Program',
      last_activity: 'Last Activity Date',
      team: 'Team',
      phq9_self_harm: 'PHQ9 Self Harm',
      checkup_date: 'Last Check-up',
      buttons: {
        view_member: 'View Member'
      }
    },
    view_member: {
      header_title: 'Member Details',
      block: {
        timeline: {
          title: 'Registration History',
          types: {
            CREATED: 'Created',
            CREATED_FROM: 'Duplicated',
            NOTIFICATION_SENT: 'Notification Sent',
            OPENED: 'Opened',
            LINK_CLICKED: 'Link Clicked',
            CANCELLED: 'Cancelled',
            ACCEPTED: 'Accepted',
            FIRST_LOGIN: 'First Login',
            LAST_ACTIVITY: 'Last Activity Date'
          }
        },
        information: {
          title: 'Contact Information',
          fields: {
            firstname: 'First Name',
            lastname: 'Last Name',
            email: 'Email',
            user_id: 'Disability ID',
            member_chosen_name: 'Member Chosen Name'
          }
        },
        details: {
          title: 'Details',
          fields: {
            organization: 'Organization',
            program: 'Program',
            business_unit: 'Business Unit',
            profession: 'Profession',
            case_manager: 'HQ user',
            referral_id: 'Referral ID',
            language: 'Language',
            team: 'Team'
          }
        },
        activity: {
          title: 'Activity',
          fields: {
            logins: 'Logins',
            check_ups: 'Check Ups',
            assessments: 'Assessments',
            goals: 'Goals Set',
            moods: 'Moods Tracked',
            thoughts: 'Thoughts Balanced',
            videos_watched: 'Videos Watched',
            polls_responded: 'Polls Responded',
            comments: 'Comments',
            sessions_started: 'Session Started',
            sessions_completed: 'Sessions Completed',
            total_session_time: 'Total Session Time',
          }
        },
        mental_health_status: {
          title: 'Goals and Skills Acquisition'
        },
        progress_viewer: {
          title: 'Progress',
          session_type: {
            title: 'Show',
            types: [
              { label: 'Training', value: 'TRAINING', moduleLabel: 'Modules', sessionLabel: 'Sessions' },
              { label: 'Exercise', value: 'EXERCISE', moduleLabel: 'Series', sessionLabel: 'Exercises' },
            ]
          },
        },
        report: {
          title: 'Report',
          fields: {
            status: 'Activity',
            skills: 'Goals and Skills Acquisition Progress',
            report_date: 'Report date',
            period_date: 'Date period',
            member_name: 'Member Name',
            user_id: 'Disability ID',
            policy_number: 'Policy Number',
            referral_date: 'Referral Date',
            accepted_date: 'Accepted Date',
            last_login: 'Last Login'
          },
          texts: {
            phase_one: 'Phase 1: Initial Assessment and Check-Up',
            phase_two: 'Phase 2: CBT Strategies',
            phase_three: 'Phase 3 : Plan to Manage Return to Work Stress',
            program_goal_title: 'Starling Minds Program Goal',
            program_goal_text: 'Based on Cognitive Behavioural Therapy (CBT) principles, our goal is to educate members and improve their position on the Mental Health continuum by developing awareness of harmful behaviours, balancing negative thoughts, and making decisions that improve their resiliency to stress, anxiety and depression both at home and in the workplace.',
            program_assessments_title: 'Assessments',
            program_assessments_text: 'Starling’s scientifically based assessment evaluates and tracks members’ results over time. It tracks self-reported symptoms (i.e. mood, physical anxiety, excessive worry/rumination) and perceived real-life functioning (i.e. work, relationships, household/finances, personal grooming, hobbies).',
            program_education_title: 'Education',
            program_education_text: 'There are 40 interactive video-based modules that contain case studies and education about CBT and mental health. Members are strongly recommended to complete one session a day and take the time to reflect and comment as they go through each module. The modules take approximately 15-20 minutes to complete and CBT homework exercises are assigned at the end of each module.',
            program_tools_title: 'Tools',
            program_tools_text: 'Starling’s CBT toolbox includes a mood tracker, a goal-setting tool, relaxation exercises, and a cognitive restructuring tool. The cognitive restructuring tool empowers the member to recognize and modify negative thought patterns both at home and at the workplace.',
            footer_confidential_disclaimer: 'CONFIDENTIAL: This page contains sensitive personal health-information, also referred to as PHI by applicable privacy laws. This information is confidential and may only be used by persons authorized to view such confidential information.',
            footer_disclaimer: 'This report will summarize material this member has covered in the program. If you require more information, please contact us at customers@starlingminds.com'
          }
        },
        detailed_report: {
          assessment_table_question: 'Over the last two weeks, how often have you been bothered by the following problems?',
          GAD7_title: 'GAD7',
          PHQ9_title: 'PHQ9',
          show_history: 'Show History',
          hide_history: 'Hide History',
          change: 'Change',
          total: 'Total',
        }
      }
    },
    assign_by_email: {
      buttons: {
        preview: 'Preview',
        send: 'Send',
        cancel: 'Cancel',
      }
    },
    reports: {
      global: {
        date: {
          CURRENT: 'Current month'
        },
        programs: {
          MENTAL_FITNESS: 'Mental Fitness',
          RTH_MENTAL: 'Return to Health - Mental',
          RTH_PHYSICAL: 'Return to Health - Physical',
          RTH_VETERANS: 'Return to Health - Veterans',
          all: 'All programs'
        },
        members: 'Members',
        referrals: 'Referrals',
        referrals_sent: 'Referrals Sent',
        accepted: 'accepted',
        min: 'Minimum',
        max: 'Maximum',
        avg: 'Average'
      },
      registrations: {
        total: 'Total',
        month: 'Month',
        quarter: 'Quarter',
        year: 'Year'
      },
      demographics: {
        BUSINESS_UNITS: {
          title: 'Business Units'
        },
        PROFESSIONS: {
          title: 'Professions'
        },
        LOCALES: {
          title: 'Languages'
        },
        GENDER: {
          title: 'Genders',
          values: {
            MALE: 'Male',
            FEMALE: 'Female',
            NON_BINARY: 'Non-binary',
            SELF_DESCRIBE: 'Self-describe',
            UNKNOWN: 'Unknown'
          }
        },
        age: 'Age'
      },
      mental_health: {
        ENERGY: {
          title: 'Energy'
        },
        STRESS: {
          title: 'Stress'
        },
        ANXIETY: {
          title: 'Anxiety'
        },
        DEPRESSION: {
          title: 'Depression'
        },
        TOP_STRESSORS: {
          title: 'Top Stressors'
        },
        STRESS_CAUSES: {
          title: 'Stress causes'
        },
        WHY_JOINED: {
          title: 'Why I joined Starling'
        }
      },
      referrals: {
        status: {
          values: {
            SENT: 'Sent',
            RESEND: 'Resend',
            OPENED: 'Opened',
            LINK_CLICKED: 'Link Clicked',
            ACCEPTED: 'Accepted',
            CANCELLED: 'Cancelled',
            EXPIRED: 'Expired',
            ERRORED: 'Failed'
          }
        }
      }
    },
    member_reports: {
      header_title: 'Member Reports',
      columns: {
        select_all: 'Select All',
        starling_hq_user: 'HQ User',
        team: 'Team',
        referral: 'Referral',
        user_ID: 'User id',
        accepted: 'Accepted Date',
        report_date: 'Report Date',
        last_download: 'Last Download',
        last_downloaded_by: 'Last downloaded by',
        downloaded: 'Downloaded'
      },
      labels: {
        apply_to_all: 'Apply to all'
      },
      buttons: {
        batch_Download: 'Batch Download'
      }
    },
    checkup_information: {
      title: 'Check-Up Information',
      cadence: {
        title: 'Check-Up Cadence',
        fields: {
          frequency: 'Frequency',
          amount: 'Amount',
          completed: 'Completed',
        },
        frequency_options: {
          member_discretion: 'Member\'s discretion',
          every_week: 'Every week',
          two_weeks: 'Every 2 weeks',
          three_weeks: 'Every 3 weeks',
          four_weeks: 'Every 4 weeks',
        },
        amount_options: {
          member_discretion: 'Member\'s discretion',
          qty_checkups: '{qty} Check-Ups',
        },
        completed_options: {
          qty_checkups: '{qty} Check-Ups',
        },
        button_send: 'Send Assignment'
      }
    },
    assessments:{
      title: 'Current Assessment Scores',
      'CD-RISC2': {
        name: 'CD-RISC2',
        label: 'Resilience',
        color: '#30CEFA',
        order: 0,
      },
      ENERGY: {
        name: 'ENERGY',
        label: 'Energy',
        color: '#08E9cf',
        order: 1,
      },
      GAD7: {
        name: 'GAD7',
        label: 'Anxiety',
        color: '#FF777D',
        order: 2,
      },
      PHQ9: {
        name: 'PHQ9',
        label: 'Depression',
        color: '#4c75aa',
        order: 3,
      },
      STRESS: {
        name: 'STRESS',
        label: 'Stress',
        color: '#ffb844',
        order: 4,
      },
      drilldown: {
        unavailable: 'No interpretation of this particular assessment is available yet.',
      },
      scoreScale: [
        {
          value: 1,
          name: 'HH',
          labels: {
            long: 'Healthy: High Average',
            short: 'Healthy +',
          },
        },
        {
          value: 2,
          name: 'HA',
          labels: {
            long: 'Healthy: Average',
            short: 'Healthy',
          },
        },
        {
          value: 3,
          name: 'HL',
          labels: {
            long: 'Healthy: Low Average',
            short: 'Healthy -',
          },
        },
        {
          value: 4,
          name: 'BL',
          labels: {
            long: 'Borderline',
            short: 'Borderline',
          },
        },
        {
          value: 5,
          name: 'ML',
          labels: {
            long: 'Mild',
            short: 'Mild',
          },
        },
        {
          value: 6,
          name: 'MO',
          labels: {
            long: 'Moderate',
            short: 'Moderate',
          },
        },
        {
          value: 7,
          name: 'SE',
          labels: {
            long: 'Severe',
            short: 'Severe',
          },
        },
      ],
      simplifiedScoreScale: [
        {
          value: 3,
          name: 'HI',
          label: 'High',
        },
        {
          value: 2,
          name: 'MD',
          label: 'Moderate',
        },
        {
          value: 1,
          name: 'LO',
          label: 'Low',
        },
        {
          value: 0,
          name: 'VL',
          label: 'Very low',
        },
        {
          value: -1,
          name: 'NOT_EVALUATED',
          label: 'Not evaluated',
          hideInScale: true,
        },
      ],
    },
    products:{
      header_title: 'Mental Fitness Training',
      recommended: {
        title: 'Recommended',
      },
      modules: {
        title: 'Modules',
        sessions: 'Sessions',
        button_explore: 'Explore',
        button_start_session: 'Start Session',
      },
      first_checkup: {
        text: 'Complete a <strong>Check-Up</strong> to generate your recommendation.',
        button: 'Take a Check-Up',
      },
      empty: {
        title: '',
        subtitle: '',
      },
      element: {
        popup: {
          tell_more_button: 'Tell me more',
          download_button: 'Download PDF',
        },
        workbook: {
          responseHelperText: '',
        },
        goal: {
          title: 'Goal created',
          subtitle: 'Good work creating your goal! Let’s work on the next few days to complete it. <br><br> This is your goal card. You can find this in your goal setter history.',
        },
        mood: {
          title: 'Mood tracked',
          subtitle: 'This is your mood card! You can find this in your mood tracker history.',
        },
        thought: {
          title: 'Thought balanced',
          subtitle: 'Good work balancing your thought. It can be very hard to think in a different manner.<br><br>This is your thought card! You can find this in your thought balancer history.',
        },
      },
      comments: {
        buttons: {
          post: 'Post',
        },
        empty: {
          title: 'There is no comment yet. Share your thoughts and write the first one.',
        },
        author: '{name} (me)',
        reply: { label: 'Reply to this comment' },
        comment: { label: 'Share a comment with the community' },
        comment_count: '{count} comment | {count} comments',
        comment_card: {
          actions: {
            delete: {
              label: 'Delete',
              icon: 'delete',
            },
            edit: {
              label: 'Edit',
              icon: 'edit',
            },
            report: {
              label: 'Report',
              icon: 'report',
            },
            reported: {
              label: 'Reported',
              icon: 'check_circle',
            },
          },
          from: 'From',
          preview: 'preview this screen',
          translated: 'This post has been translated from its original language.',
          translated_cancel: 'Show post in its original language.',
          reply: 'reply',
          replies: 'replies',
          helpfuls: 'likes',
          helpful: 'like',
          report: {
            title: 'Report Comment',
            subtitle: 'Thank you for reporting this comment, please let us know the reason for reporting it.',
            reasons: [
              'Contains offensive language, harassment or abuse',
              'It\'s spam or is off-topic',
              'Indicates potential for self-harm or suicidal thoughts',
            ],
          },
        },
        sorts: [ 'Sort By Newest', 'Sort By Oldest', 'Sort By Likes' ],
        notifications: {
          reported: 'Comment reported',
          updated: 'Comment updated',
          deleted: 'Comment deleted',
          helpful_marked: 'Comment liked',
          helpful_unmarked: 'Comment unliked',
          replied: 'Reply added',
          commented: 'Comment added',
        },
      },
      element_types: {
        video: {
          title: 'Video',
          icon: 'mdi-play-box-outline',
          color: '#5CCEFF',
        },
        workbook: {
          title: 'Workbook',
          icon: 'mdi-book-open-page-variant',
          responseLabel: 'Your Response',
          responseHelperText: '',
          color: '#C288CB',
        },
        poll: {
          title: 'Poll',
          icon: 'mdi-poll-box-outline',
          color: '#75CB99',
        },
        question: {
          title: 'Question',
          icon: 'mdi-account-question',
          color: '#FFD176',
        },
        decision: {
          title: 'Decision',
          icon: 'mdi-arrow-decision',
          color: '#FFA4A9',
          subtitle: 'Choose what you would like to do next',
        },
        submenu: {
          title: 'Submenu',
          icon: 'mdi-menu-open',
          color: '#0098E1',
          subtitle: 'Choose what you would like to do next',
        },
        tool: {
          title: 'Tool',
          icon: 'mdi-tools',
          color: '#9099AD',
        },
        mood: {
          title: 'Mood Tracker',
          icon: 'mdi-emoticon-confused',
          color: '#FFB92E',
        },
        html: {
          title: 'Note',
          icon: 'mdi-note',
          color: '#6A89FF',
        },
        goal: {
          title: 'Goal Setter',
          icon: 'mdi-mountain',
          color: '#6CC5B9',
        },
        assessment: {
          title: 'Assessment',
          icon: 'mdi-head-cog',
          color: '#FF8884',
        },
        thoughts: {
          title: 'Thought Balancer',
          icon: 'mdi-weather-lightning-rainy',
          color: '#E1CCF1',
        },
        mcq: {
          title: 'MCQ',
          icon: 'mdi-format-list-bulleted-square',
          color: '#E1CCF1',
        },
        slider: {
          title: 'Slider',
          icon: 'mdi-gauge',
          color: '#ff9800',
        },
        composition: {
          title: 'Composition',
          icon: 'mdi-animation-outline',
          color: '#7E8DC1',
        },
        next_step: {
          title: 'Next Step',
          icon: 'mdi-page-next',
          color: '#736010',
        },
        popup: {
          title: 'Popup',
          icon: 'mdi-launch',
          color: '#CABE70',
        },
      },
      assessment_history_chart: {
        title: 'Assessment History',
        chart: {
          label: {
            xAxis: 'Dates',
            xAxisVersion: 'final',
            yAxis: 'Score',
          },
          score: {
            label: {
              severe: 'Severe',
              moderate: 'Moderate',
              mild: 'Mild',
              border_line: 'Borderline',
              healthy_low: 'Healthy: Low Average',
              healthy_average: 'Healthy: Average',
              helthy_high: 'Healthy: High Average',
            },
          },
          assessment: {
            label: {
              gad7: 'ANXIETY',
              phq9: 'DEPRESSION',
              stress: 'STRESS',
              energy: 'ENERGY',
              'cd-risc2': 'RESILIENCE',
            },
          },
        },
      },
      parts: {
        guide: {
          read_more: 'Read more',
          read_less: 'Read less',
        },
      }
    },
    sso: {
      errors: {
        default: 'An error occurred, you are not logged in.',
        undefined: 'An error occurred, you are not logged in.',
        sso_configuration: 'There is a configuration error.',
        user_disabled: 'Your user account is not enabled.'
      }
    },
    login: {
      error: {
        sunset_with_org_email: 'Your account is no longer active as {sunsetOrganizationName}\'s contract with Starling Minds ended on {sunsetEffectiveDate}.<br/><br/> If you have any questions, please don\'t hesitate to reach out to your organization at {sunsetContactEmail}.',
        sunset_without_org_email: 'Your account is no longer active as {sunsetOrganizationName}\'s contract with Starling Minds ended on {sunsetEffectiveDate}.<br/><br/> If you have any questions, please don\'t hesitate to reach out to your organization.',
      }
    }
  },
  assign_by_email: {}
};
